import { usePsfOnlyShareChannels } from 'src/app/pages/psf/share/shared/hooks';
import { useAvailableShareActions } from 'src/app/shared/hooks/share';

import { useShareOptions } from './options';

export function usePsfShareAvailableShareActions() {
	const options = useShareOptions();
	const channels = usePsfOnlyShareChannels();
	return useAvailableShareActions(channels, options);
}
